import { createApi } from '@reduxjs/toolkit/query/react';
import { customBaseQuery } from '../../utils/customBaseQuery';

export const topupApi = createApi({
	reducerPath: 'topupApi',
	baseQuery: customBaseQuery,
	endpoints: (builder) => ({
		// Серверная котировка по текущей public-корзине пользователя
		calculateTopUp: builder.mutation({
			query: ({ promoCodeId = null } = {}) => ({
				url: '/keys/PS_keys/order/calculate-topup',
				method: 'POST',
				body: { promoCodeId },
			}),
		}),
		// Создание заказа на пополнение из корзины игр
		createTopUpOrder: builder.mutation({
			query: ({ data }) => ({
				url: '/keys/PS_keys/order/create-from-public',
				method: 'POST',
				body: data,
			}),
		}),
	}),
});

export const {
	useCalculateTopUpMutation,
	useCreateTopUpOrderMutation,
} = topupApi;
